import { replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '../../../../../common-utils/libraries/axios/axios';
import { SUBSCRIPTIONS } from '../apiUrls';

const mutationMigrateSubscription = (onSuccess, onError) => {
    return {
        mutationFn: ({ subscriptionId }) => {
            return client.post(
                replaceParameters(SUBSCRIPTIONS.MIGRATE.url, { subscriptionId: subscriptionId })
            );
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationMigrateSubscription;